import React, { useState, useEffect } from "react";
import logo from "../assets/img/logos/logo-white-no-bg.png";
import { Button } from "@mui/material";
import { IoLogoGoogle, IoLogoLinkedin } from "react-icons/io5";
import Batteries from "../assets/loginPage.png";
import { Link, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { Login } from "../components/Auth/Login";
import { useAuth } from "../contexts/auth";
import { useHttp } from "../hooks/useHttp";
import { Loader } from "../components/Loaders/loader";
import { GoogleLogin } from "@react-oauth/google";
import { useLinkedIn } from 'react-linkedin-login-oauth2';

export const LoginPage = () => {
  const { setRole, setUser } = useAuth();
  const navigate = useNavigate();
  const [pageLoading, setPageLoading] = useState(false);
  const { loading, sendRequest, error, clearError, data } = useHttp();

  const handleLogin = async (userData) => {
    await sendRequest("users/login", "POST", userData);
  };

  const handleLoginAsGuest = async () => {
    const guestCredentials = {
      email: "demo1@gmail.com",
      password: "Qwerty@00",
    };

    await handleLogin(guestCredentials);
  };

  const handleGoogleLogin = async (response) => {
    const token = response.credential;
    const googleData = {
      tokenId: token,
    };
    await sendRequest("users/google-login", "POST", googleData);
  }

  const { linkedInLogin } = useLinkedIn({
    clientId: '77rn54wu73imwy',
    redirectUri: `${window.location.origin}/linkedin`,
    onSuccess: (code) => {
      console.log(code);
    },
    onError: (error) => {
      console.log(error);
    },
  });


  useEffect(() => {
    if (data) {
      const user = jwtDecode(data.token);
      localStorage.setItem("token", data.token);
      setRole(user.role);
      setUser(user);
      setPageLoading(true);
      navigate("/auth");
    }
  }, [data]);

  return (
    <>
      {pageLoading ? (
        <Loader />
      ) : (
        <div className="flex flex-row min-h-screen max-md:bg-loginPage ">
          <div className="flex flex-col items-center w-[50%] max-md:w-full max-md:py-4 pt-8 gap-8 bg-white-translucent md:bg-[white] px-5 md:px-10">
            <div className="flex flex-col gap-8 w-[100%] lg:w-[400px] xl:w-[600px] self-center items-center">

              {/* <div className="max-md:self-center">
                <img src={logo} alt="ThinkClock Battery Labs" className="max-w-60 lg:max-w-80" />
              </div> */}
              <h1 className="mt-5 text-[#808080] text-2xl max-md:text-center">Please Log Into Your Scope</h1>

              <div className="flex flex-col w-[90%] md:w-[60%]">
                <Login onSubmit={handleLogin} loading={loading} />
              </div>
              <div className="flex flex-row md:gap-0 items-center justify-between w-[90%]">
                <Link to={"/signup"} className="flex flex-row text-[#e85d01] text-sm md:text-lg gap-2">
                  {/* <span className="text-[#ffffffd0]">New User ?</span>  */}
                  <Button
                    size="small"
                    variant="contained"
                    sx={{
                      width: "140px",
                      backgroundColor: "#e8442d",
                      fontFamily: "Bai Jamjuree",
                      color: "white",
                      fontWeight: "900",
                      "&:hover": {
                        backgroundColor: "#e85d01",
                      },
                      "&:active": {
                        backgroundColor: "#e85d01",
                      },
                    }}
                  >
                    Sign Up
                  </Button>
                </Link>
                {/* <div className="text-[#e85d01] text-sm md:text-lg cursor-pointer" onClick={handleLoginAsGuest}>
                  Login as guest
                </div> */}
                <Button
                      size="small"
                      variant="contained"
                      onClick={handleLoginAsGuest}
                      sx={{
                        width: "140px",
                        backgroundColor: "#e8442d",
                        fontFamily: "Bai Jamjuree",
                        color: "white",
                        fontWeight: "900",
                        "&:hover": {
                          backgroundColor: "#e85d01",
                        },
                        "&:active": {
                          backgroundColor: "#e85d01",
                        },
                      }}
                    >
                      Login as Guest
                    </Button>
              </div>

              <div className="flex flex-col items-center gap-4 w-[100%]">
                <GoogleLogin
                  theme="filled_blue"
                  size="large"
                  onSuccess={handleGoogleLogin}
                  onFailure={() => { }}
                  width="240px"
                  cookiePolicy={'single_host_origin'}
                />
                {/* <Button
                variant="contained"
                startIcon={<IoLogoGoogle />}
                size="large"
                onClick={handleGoogleButtonClick}
                sx={{
                  backgroundColor: "#e8442d",
                  color: "white",
                  fontWeight: "900",
                  fontFamily: "Bai Jamjuree",
                  "&:hover": {
                    backgroundColor: "#e85d01",
                  },
                  "&:active": {
                    backgroundColor: "#e85d01",
                  },
                }}
              >
                Login with Google
              </Button> */}
                <Button
                width="250px"
                  variant="contained"
                  startIcon={<IoLogoLinkedin />}
                  size="large"
                  sx={{
                    backgroundColor: "#0A66C2",
                    color: "white",
                    fontWeight: "900",
                    fontFamily: "Bai Jamjuree",
                    "&:hover": {
                      backgroundColor: "#0072b1",
                    },
                    "&:active": {
                      backgroundColor: "#0072b1",
                    },
                  }}
                  onClick={linkedInLogin}
                >
                  Login with LinkedIn
                </Button>
              </div>

            </div>
          </div>
          <div className="hidden md:flex w-[50%]">
            <img src={Batteries} alt="" className="object-cover w-full h-full" />
          </div>
        </div>
      )}
    </>
  );
};
